import React, { useContext, useEffect, useRef, useState } from "react";
import Table from "../../Common/Table/Table";
import {
  VYLABS_BASE_URL,
  GET_ALL_REPORTS,
  SUBMIT_DAILY_REPORT,
  METRICS_RECRUITER_DASHBOARD_SUMMARY,
  METRICS_RECENT_ACTIVITY,
  GET_DAILY_REPORT,
  UPDATE_DAILY_REPORT,
} from "../../helper/url_helper";
import { post, get, put } from "../../helper/Api_helper";
import "./DailyReport.css";
import { DynamicContext } from "../../Context/DynamicContext";
import { getStageColor } from "../../Common/constants/stageColors";
import ReportSummaryCards from "../../Common/Card/Report-Card/ReportSummaryCards";
import Button from "../../Common/Button/Button";
import reportIcon from "../../Assets/Images/report-page-icon.svg";
import reportDarkIcon from "../../Assets/Images/report-page-icon-dark.svg";
import SidePopup from "../../Common/SidePopup/SidePopup";
import TextArea from "../../Common/TextArea/TextArea";
import { useFormik } from "formik";
import * as Yup from "yup";
import MetricsCard from "../../Common/Card/Metrics-Card/MetricsCard";
import moment from "moment";
import { CustomDatePickerModal } from "../../Common/Date-Picker/DatePicker";
import calendarIcon from "../../Assets/Images/calendarIcon.png";
import darkCalendarIcon from "../../Assets/Images/calendar-dark-Icon.png";
import DynamicAutocomplete from "../../Common/AutoSuggestion/DynamicAutocomplete";
import DynamicListUsers from "../../Common/DynamicListUsers/DynamicListUsers";
import eyeIcon from "../../Assets/Images/Eye-Icon.svg";
import VybogTALLoaderAnimation from "../../Common/Dynamic-Animations/DynamicAnimations";
import NoActivityDark from "../../Assets/Images/no-activity-dark.svg";
import NoActivityLight from "../../Assets/Images/no-activity-light.svg";
import AdminReportSummaryCards from "../../Common/Card/Report-Card/AdminReportsummaryCards";
import cancelIcon from "../../Assets/Images/cancel-icon.svg";
import editIcon from "../../Assets/Images/cf-edit-icon-dark.svg";
import editLightIcon from "../../Assets/Images/cf-edit-icon-light.svg";
// import deleteIcon from "../../Assets/Images/cf-delete-icon-dark.svg";
// import deleteLightIcon from "../../Assets/Images/cf-delete-icon-light.svg";
import ContentDialog from "../../Common/Content-Dialog/ContentDialog";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import CustomTooltip from "../../Common/Tooltip/Tooltip";

function DailyReport() {
  const { userDetails, isDarkMode, AdminAccess } = useContext(DynamicContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [reportsData, setReportsData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [submittedToday, setSubmittedToday] = useState(false);
  const [todayWorkingHours, setTodayWorkingHours] = useState(null);
  const [reportCheckInTime, setReportCheckInTime] = useState(null);
  const [reportCheckOutTime, setReportCheckOutTime] = useState(null);
  const [isSidePopupOpen, setIsSidePopupOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [metricsData, setMetricsData] = useState(null);
  const [recentActivity, setRecentActivity] = useState([]);
  const [recentActivityLoading, setRecentActivityLoading] = useState(false);
  const [recentActivityOffset, setRecentActivityOffset] = useState(0);
  const [recentActivityHasMore, setRecentActivityHasMore] = useState(true);
  const RECENT_ACTIVITY_LIMIT = 5;
  const [isViewPopupOpen, setIsViewPopupOpen] = useState(false);
  const [viewReportData, setViewReportData] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);
  const [checkOutTime, setCheckOutTime] = useState(new Date());
  const [todayCheckInTime, setTodayCheckInTime] = useState(null);
  const [lastCheckOutTime, setLastCheckOutTime] = useState(null);
  const [totalSubmitted, setTotalSubmitted] = useState(0);
  const [totalNotSubmitted, setTotalNotSubmitted] = useState(0);
  const [totalRecruiters, setTotalRecruiters] = useState(0);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [openRangePicker, setOpenRangePicker] = useState(null);
  const [rangePickerPosition, setRangePickerPosition] = useState({
    top: null,
    left: null,
  });
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [editingReportId, setEditingReportId] = useState(null);
  const [editRemarks, setEditRemarks] = useState("");
  const [isEditSubmitting, setIsEditSubmitting] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  const openDateRangePicker = (pickerType) => {
    const targetRef = pickerType === "from" ? fromDateRef : toDateRef;
    const rect = targetRef.current?.getBoundingClientRect();
    if (!rect) return;

    setRangePickerPosition({
      top: rect.bottom + 5,
      left: rect.left,
    });
    requestAnimationFrame(() => setOpenRangePicker(pickerType));
  };

  const handleFromDateSelect = (date) => {
    setFromDate(date);
    setOpenRangePicker(null);
    setRangePickerPosition({ top: null, left: null });
    setCurrentPage(1);
  };

  const handleToDateSelect = (date) => {
    setToDate(date);
    setOpenRangePicker(null);
    setRangePickerPosition({ top: null, left: null });
    setCurrentPage(1);
  };

  const handleFromDateClear = (e) => {
    e.stopPropagation();
    setFromDate(null);
    setCurrentPage(1);
  };

  const handleToDateClear = (e) => {
    e.stopPropagation();
    setToDate(null);
    setCurrentPage(1);
  };

  const fetchReportDetails = async (reportId, rawReport) => {
    setIsViewPopupOpen(true);
    setViewLoading(true);
    setViewReportData(null);
    setMetricsData(null);
    setRecentActivity([]);
    setRecentActivityOffset(0);
    setRecentActivityHasMore(true);
    try {
      const response = await get(
        VYLABS_BASE_URL,
        `${GET_DAILY_REPORT}?id=${reportId}`,
      );
      if (response) {
        setViewReportData(response);
      }

      const userId = rawReport?.user_id;
      const reportDate = rawReport?.report_date
        ? moment(rawReport.report_date).format("YYYY-MM-DD")
        : null;

      if (userId && reportDate) {
        await Promise.all([
          getRecruiterDashboardSummary(userId, reportDate, reportDate),
          getRecentActivity(0, false, userId, reportDate, reportDate),
        ]);
      }
    } catch (error) {
      console.log("fetchReportDetails", error);
    } finally {
      setViewLoading(false);
    }
  };

  const handleCloseViewPopup = () => {
    setIsViewPopupOpen(false);
    setViewReportData(null);
    setMetricsData(null);
    setRecentActivity([]);
  };
  const handleUserSelect = (value) => {
    setSelectedMember(value || null);
    setCurrentPage(1);
  };

  const validationSchema = Yup.object({
    remarks: Yup.string().required("Remarks is required"),
  });

  const formik = useFormik({
    initialValues: {
      remarks: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      await submitTodayReport(values.remarks, resetForm);
    },
  });
  const getRecruiterDashboardSummary = async (userId, fromDate, toDate) => {
    try {
      let url = `${METRICS_RECRUITER_DASHBOARD_SUMMARY}`;
      const params = [];
      if (userId) params.push(`userId=${userId}`);
      if (fromDate) params.push(`fromDate=${fromDate}`);
      if (toDate) params.push(`toDate=${toDate}`);
      if (params.length) url += `?${params.join("&")}`;

      const response = await get(VYLABS_BASE_URL, url);
      if (response) {
        setMetricsData(response);
      }
    } catch (error) {
      console.error("error in getRecruiterDashboardSummary", error);
    }
  };

  const getRecentActivity = async (
    offset = 0,
    append = false,
    userId,
    fromDate,
    toDate,
  ) => {
    try {
      setRecentActivityLoading(true);
      let url = `${METRICS_RECENT_ACTIVITY}?limit=${RECENT_ACTIVITY_LIMIT}&offset=${offset}`;
      if (userId) url += `&userId=${userId}`;
      if (fromDate) url += `&fromDate=${fromDate}`;
      if (toDate) url += `&toDate=${toDate}`;

      const response = await get(VYLABS_BASE_URL, url);
      const activities = response?.activities || [];

      setRecentActivity((prev) =>
        append ? [...prev, ...activities] : activities,
      );
      setRecentActivityOffset(offset + activities.length);
      setRecentActivityHasMore(Boolean(response?.hasMore));
    } catch (error) {
      console.error("error in getRecentActivity", error);
    } finally {
      setRecentActivityLoading(false);
    }
  };

  const renderRecentActivity = () => (
    <>
      {recentActivity.map((item, index) => (
        <div
          key={item.id || index}
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "14px",
            marginBottom: "5px",
            marginRight: "8px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: getStageColor(item.stage),
              }}
            />
            {index !== recentActivity.length - 1 && (
              <div
                style={{
                  width: "1px",
                  flex: 1,
                  background: "#7A7A7A",
                  minHeight: "52px",
                  marginTop: "2px",
                }}
              />
            )}
          </div>

          <div style={{ flex: 1 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div style={{ fontSize: "16px", fontWeight: 600 }}>
                {item.candidateName} → {item.stage}
              </div>
              <div style={{ color: "#7A7A7A", fontSize: "14px" }}>
                {moment(item.occurredAt).format("hh:mm A")}
              </div>
            </div>
            <div
              style={{ marginTop: "4px", color: "#6D6D6D", fontSize: "14px" }}
            >
              {item.jobTitle} • {item.clientName}
            </div>
          </div>
        </div>
      ))}
    </>
  );

  const transformTableData = (apiData) => {
    return apiData.map((item) => ({
      id: item.id,
      name: `${item.first_name} ${item.last_name}`,
      reportDate: item.report_date
        ? moment(item.report_date).format("MMM D, YYYY")
        : "--",
      inTime: formatTime(item.check_in_time),
      outTime: formatTime(item.check_out_time),
      workedHours: formatWorkingHours(item.Working_hours),
      tracked: item.tracked_count || 0,
      proposed: item.proposed_count || 0,
      interested: item.interested_count || 0,
      interview: item.interview_count || 0,
      raw: item,
    }));
  };

  const isToday = (dateString) => {
    if (!dateString) return false;
    const reportDate = moment(dateString);
    const today = moment();
    return reportDate.isSame(today, "day");
  };

  const formatTime = (datetime) => {
    if (!datetime) return "--:--";
    const parsed = moment.parseZone(datetime, "YYYY-MM-DD hh:mm:ss A Z");
    if (!parsed.isValid()) return "--:--";
    return parsed.format("hh:mm A");
  };

  const formatWorkingHours = (hoursStr) => {
    if (!hoursStr) return "0h 0m";
    const [hours, minutes] = hoursStr.split(":");
    return `${parseInt(hours)}h ${parseInt(minutes)}m`;
  };

  const getInitials = (first_name, last_name) => {
    const first = first_name?.[0] || "";
    const last = last_name?.[0] || "";
    return `${first}${last}`.toUpperCase() || "U";
  };

  const formatDateHeader = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  };

  const formatClockTime = (date) => {
    if (!date) return "--:--";
    const dateObj =
      typeof date === "string"
        ? moment(date, "YYYY-MM-DD hh:mm:ss A Z")
        : moment(date);
    return dateObj.format("hh:mm A");
  };

  const fetchAllReports = async () => {
    setLoading(true);
    try {
      let url = `${GET_ALL_REPORTS}?limit=${perPage}&offset=${(currentPage - 1) * perPage}`;
      if (!fromDate && !toDate) {
        url += `&dateRange=${"today"}`;
      }

      if (fromDate) {
        url += `&startDate=${moment(fromDate).format("YYYY-MM-DD")}`;
      }
      if (toDate) {
        url += `&endDate=${moment(toDate).format("YYYY-MM-DD")}`;
      }
      const selectedUserId =
        typeof selectedMember === "object"
          ? selectedMember?.value
          : selectedMember;

      if (selectedUserId) {
        url += `&user_id=${selectedUserId}`;
      }

      const response = await get(VYLABS_BASE_URL, url);

      if (response) {
        const reportsArray = Array.isArray(response.reports)
          ? response.reports
          : [];
        const transformedData = transformTableData(reportsArray);
        setReportsData(transformedData);
        setTotalRecords(response.total || 0);
        setSubmittedToday(response.submitted_today || false);
        setTodayWorkingHours(response.today_working_hours || null);
        setReportCheckInTime(response.check_in_time || null);
        setReportCheckOutTime(response.check_out_time || null);
        setTodayCheckInTime(response.today_check_in_time || null);
        setLastCheckOutTime(response.last_check_out_time || null);
        setTotalSubmitted(response.total_submitted || 0);
        setTotalNotSubmitted(response.total_not_submitted || 0);
        setTotalRecruiters(response.total_recruiters || 0);
      } else {
        setReportsData([]);
        setTotalRecords(0);
        setTodayWorkingHours(null);
        setReportCheckInTime(null);
        setReportCheckOutTime(null);
        setTodayCheckInTime(null);
        setLastCheckOutTime(null);
        setTotalSubmitted(0);
        setTotalNotSubmitted(0);
        setTotalRecruiters(0);
      }
    } catch (error) {
      console.log("fetchAllReports", error);
      setReportsData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  const submitTodayReport = async (remarks, resetForm) => {
    setIsSubmitting(true);
    try {
      await post(VYLABS_BASE_URL, SUBMIT_DAILY_REPORT, {
        report_content: remarks,
        timezone: userDetails?.timezone,
      });
      setIsSidePopupOpen(false);
      resetForm();
      setSubmittedToday(true);
      Toast("success", "Report submitted successfully");
      await fetchAllReports();
    } catch (error) {
      console.log("submitTodayReport", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const updateDailyReport = async (reportId, reportContent) => {
    setIsEditSubmitting(true);
    try {
      await put(VYLABS_BASE_URL, `${UPDATE_DAILY_REPORT}?id=${reportId}`, {
        report_content: reportContent,
      });
      setIsEditPopupOpen(false);
      setEditingReportId(null);
      setEditRemarks("");
      Toast("success", "Report updated successfully");
      await fetchAllReports();
    } catch (error) {
      console.log("updateDailyReport", error);
    } finally {
      setIsEditSubmitting(false);
    }
  };

  const handleEditReport = (rowId, rowData) => {
    const report = reportsData.find((item) => item.id === rowId);
    if (report) {
      setEditingReportId(rowId);
      setEditRemarks(report.raw.report_content || "");
      setIsEditPopupOpen(true);
    }
  };

  const handleCloseEditPopup = () => {
    setIsEditPopupOpen(false);
    setEditingReportId(null);
    setEditRemarks("");
  };

  const handleEditSubmit = () => {
    if (editRemarks.trim()) {
      updateDailyReport(editingReportId, editRemarks);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (rowsPerPage) => {
    setPerPage(rowsPerPage);
    setCurrentPage(1);
  };

  const handleOpenSidePopup = () => {
    setIsSidePopupOpen(true);
    setCheckOutTime(new Date());
    formik.resetForm();
    formik.setFieldTouched("remarks", false);
    setRecentActivity([]);
    setRecentActivityOffset(0);
    setRecentActivityHasMore(true);
    getRecentActivity(0, false);
    getRecruiterDashboardSummary();
  };

  useEffect(() => {
    if (!isSidePopupOpen) return;
    const timer = setInterval(() => {
      setCheckOutTime(new Date());
    }, 1000 * 30);
    return () => clearInterval(timer);
  }, [isSidePopupOpen]);

  const handleCloseSidePopup = () => {
    setIsSidePopupOpen(false);
    formik.resetForm();
  };

  const handleSidePopupSubmit = () => {
    formik.handleSubmit();
  };

  useEffect(() => {
    fetchAllReports();
  }, [
    currentPage,
    perPage,
    userDetails?.user_id,
    fromDate,
    toDate,
    selectedMember?.value,
  ]);

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
        <strong
          style={{
            cursor: "pointer",
            opacity: 0.7,
            transition: "opacity 0.2s",
          }}
          onMouseEnter={(e) => (e.target.style.opacity = 1)}
          onMouseLeave={(e) => (e.target.style.opacity = 0.7)}
          onClick={() => fetchReportDetails(row.id, row.raw)}
        >
          {row.name}
        </strong>
      ),
    },
    {
      name: "Report Date",
      selector: (row) => row.reportDate,
      sortable: true,
    },
    {
      name: "Check In",
      selector: (row) => row.inTime,
      sortable: true,
    },
    {
      name: "Check Out",
      selector: (row) => row.outTime,
      sortable: true,
      cell: (row) => (
        <CustomTooltip
          title={
            row.raw?.created_at
              ? moment(row.raw.created_at).format("MMM D, YYYY hh:mm A")
              : "No data"
          }
          placement="top"
        >
          <span>{row.outTime}</span>
        </CustomTooltip>
      ),
    },
    {
      name: "Worked Hours",
      selector: (row) => row.workedHours,
      sortable: true,
    },
    {
      name: "Tracked",
      selector: (row) => row.tracked,
      sortable: true,
      right: true,
    },
    {
      name: "Proposed",
      selector: (row) => row.proposed,
      sortable: true,
      right: true,
    },
    {
      name: "Interested",
      selector: (row) => row.interested,
      sortable: true,
      right: true,
    },
    // {
    //   name: "Interview",
    //   selector: (row) => row.interview,
    //   sortable: true,
    //   right: true,
    // },
    {
      name: "Actions",
      cell: (row) => {
        const reportDate = row.raw?.report_date;
        const canEdit = reportDate ? isToday(reportDate) : false;
        return (
          <div
            style={{
              display: "flex",
              gap: "8px",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "80px",
            }}
          >
            <img
              src={eyeIcon}
              alt="View Report"
              style={{
                cursor: "pointer",
                opacity: 0.7,
                transition: "opacity 0.2s",
              }}
              onMouseEnter={(e) => (e.target.style.opacity = 1)}
              onMouseLeave={(e) => (e.target.style.opacity = 0.7)}
              onClick={() => fetchReportDetails(row.id, row.raw)}
            />
            {!AdminAccess && canEdit && (
              <img
                src={isDarkMode ? editIcon : editLightIcon}
                alt="Edit"
                style={{
                  cursor: "pointer",
                  opacity: 0.7,
                  transition: "opacity 0.2s",
                }}
                onMouseEnter={(e) => (e.target.style.opacity = 1)}
                onMouseLeave={(e) => (e.target.style.opacity = 0.7)}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditReport(row.id, row.raw);
                }}
              />
            )}
            {/* <img
            src={isDarkMode ? deleteIcon : deleteLightIcon}
            alt="Delete"
            style={{
              cursor: "pointer",
              opacity: 0.7,
              transition: "opacity 0.2s",
            }}
            onMouseEnter={(e) => (e.target.style.opacity = 1)}
            onMouseLeave={(e) => (e.target.style.opacity = 0.7)}
            onClick={(e) => {
              e.stopPropagation();
            }}
          /> */}
          </div>
        );
      },
      width: "100px",
      center: "true",
      ignoreRowClick: true,
    },
  ];

  return (
    <div>
      <div className="header-main-container daily-report-header-row">
        <div className="header-icon-title-container">
          <img
            src={isDarkMode ? reportDarkIcon : reportIcon}
            alt="reportDarkIcon"
            className="header-title-icon"
          />
          <h2 className="daily-report-title">Daily Reports</h2>
        </div>
        {/* {(userDetails?.role === "MANAGER" ||
          userDetails?.role === "MEMBER") && ( */}
          <div className="report-button-container">
            <Button
              label="Submit Today's Report"
              event={handleOpenSidePopup}
              disabled={submittedToday}
            />
          </div>
        {/* )} */}
      </div>

      <div className="daily-report-container">
        {(userDetails?.role === "MANAGER" ||
          userDetails?.role === "MEMBER") && (
          <ReportSummaryCards
            submittedToday={submittedToday}
            todayWorkingHours={todayWorkingHours}
            checkInTime={reportCheckInTime}
            checkOutTime={reportCheckOutTime}
            lastCheckOutTime={lastCheckOutTime}
          />
        )}

        {userDetails?.role === "ADMIN" && (
          <AdminReportSummaryCards
            totalSubmitted={totalSubmitted}
            totalRecruiters={totalRecruiters}
            totalNotSubmitted={totalNotSubmitted}
          />
        )}

        <div className="daily-report-filters-bar">
          {userDetails?.role === "ADMIN" && (
            <div className="daily-report-user-select">
              <DynamicListUsers
                value={selectedMember}
                onChange={(value) => handleUserSelect(value)}
                placeholder="Select User"
                usersSx ={{
                  "&& .MuiInputBase-root": {
                    marginBottom: "12px",
                  },
                  ".MuiOutlinedInput-root": {
                    borderRadius: "8px",
                    height: "40px",
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "1px solid var(--border-color, #e0e0e0)",
                      top: "2px",
                      borderRadius: "8px",
                    },
                  },
                  ".MuiInputBase-input": {
                    color: "var(--header__color)",
                    padding: "8px 12px 0 8px !important",
                  },
                }}
                usersComponentProps={{
                  popper: {
                    sx: {
                      "& .MuiAutocomplete-paper": {
                        backgroundColor: isDarkMode ? "#141518" : "#ffffff",
                        color: isDarkMode ? "#ffffff" : "#1f1f1f",
                        border: isDarkMode
                          ? "1px solid rgba(255, 255, 255, 0.18)"
                          : "1px solid var(--border-color, #e0e0e0)",
                        boxShadow: isDarkMode
                          ? "0 10px 24px rgba(0, 0, 0, 0.45)"
                          : "0 10px 24px rgba(0, 0, 0, 0.12)",
                      },
                      "& .MuiAutocomplete-listbox": {
                        backgroundColor: isDarkMode ? "#141518" : "#ffffff",
                        color: isDarkMode ? "#ffffff" : "#1f1f1f",
                      },
                      "& .MuiAutocomplete-option": {
                        backgroundColor: isDarkMode ? "#141518" : "#ffffff",
                        color: isDarkMode ? "#ffffff" : "#1f1f1f",
                        "&.Mui-focused, &:hover": {
                          backgroundColor: isDarkMode
                            ? "rgba(104, 96, 238, 0.28)"
                            : "#f5f5f5",
                        },
                        '&[aria-selected="true"]': {
                          backgroundColor: isDarkMode
                            ? "rgba(104, 96, 238, 0.38)"
                            : "#eeeeee",
                        },
                      },
                      "& .MuiAutocomplete-noOptions": {
                        color: isDarkMode ? "#aea9ff" : "#6860ee",
                      },
                      "& .MuiAutocomplete-loading": {
                        color: isDarkMode ? "#aea9ff" : "#6860ee",
                        fontStyle: "italic",
                      },
                    },
                  },
                }}
              />
            </div>
          )}

          <div className="daily-report-date-range">
            <button
              ref={fromDateRef}
              type="button"
              className="stage-date-range-control date-range-control"
              onClick={() => openDateRangePicker("from")}
            >
              <img
                alt=""
                src={isDarkMode ? darkCalendarIcon : calendarIcon}
                className="date-range-icon"
              />
              <span
                className={`date-range-label${fromDate ? " date-range-label--active" : ""}`}
              >
                {fromDate
                  ? moment(fromDate).format("MMM D, YYYY")
                  : "From Date"}
              </span>
              {fromDate && (
                <img
                  alt="Clear from date"
                  src={cancelIcon}
                  className="date-range-cancel-icon"
                  onClick={handleFromDateClear}
                />
              )}
            </button>
            <span>-</span>
            <button
              ref={toDateRef}
              type="button"
              className="stage-date-range-control date-range-control"
              onClick={() => openDateRangePicker("to")}
            >
              <img
                alt=""
                src={isDarkMode ? darkCalendarIcon : calendarIcon}
                className="date-range-icon"
              />
              <span
                className={`date-range-label${toDate ? " date-range-label--active" : ""}`}
              >
                {toDate ? moment(toDate).format("MMM D, YYYY") : "To Date"}
              </span>
              {toDate && (
                <img
                  alt="Clear to date"
                  src={cancelIcon}
                  className="date-range-cancel-icon"
                  onClick={handleToDateClear}
                />
              )}
            </button>
          </div>
        </div>

        <div className="daily-report-table">
          <Table
            columns={columns}
            data={reportsData}
            pagination={true}
            paginationServer={true}
            currentPage={currentPage}
            paginationPerPage={perPage}
            paginationRowsPerPageOptions={[5, 10, 15, 20]}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handleRowsPerPageChange}
            paginationTotalRows={totalRecords}
            highlightOnHover={true}
            fixedHeader={true}
            fixedHeaderScrollHeight="400px"
            progressPending={loading}
            dataNotFoundMessage="No report records were found"
            backgroundColor="var(--body__background)"
            color="var(--header__color)"
            customStyle={{
              headCells: {
                fontSize: "12px !important",
                width: "10px !important",
              },
              cells: {
                fontSize: "12px",
              },
            }}
          />
        </div>
      </div>

      <SidePopup
        isOpen={isSidePopupOpen || isViewPopupOpen}
        onClose={isViewPopupOpen ? handleCloseViewPopup : handleCloseSidePopup}
        title={isViewPopupOpen ? "Report Details" : "Submit Today's Report"}
        subTitle={
          isViewPopupOpen
            ? "View submitted daily report"
            : "Please provide your daily report remarks"
        }
        direction="right"
        sidePopupWidth="80%"
        showHeader={true}
        headerBackgroundColor="var(--body__background)"
        titleColor="var(--header__color)"
        subTitleColor="#62748a"
        closeOnOverlayClick={!isViewPopupOpen}
        headerContent={
          <div className="side-popup-header-content">
            <div>
              <h2 className="side-popup-header-title">
                {isViewPopupOpen ? "Report Details" : "Submit Today's Report"}
              </h2>
              <p className="side-popup-header-subtitle">
                {isViewPopupOpen
                  ? "View submitted daily report"
                  : "Please provide your daily report remarks"}
              </p>
            </div>
          </div>
        }
        headerRightComponent={
          isViewPopupOpen ? null : (
            <Button
              label={isSubmitting ? "Submitting..." : "Submit"}
              event={handleSidePopupSubmit}
              disabled={isSubmitting || !formik.isValid || !formik.dirty}
              backgroundColor="#6860EE"
              color="#FFFFFF"
              border="none"
              style={{ padding: "8px 20px" }}
            />
          )
        }
      >
        <div className="side-popup-content">
          {isViewPopupOpen && viewLoading ? (
            <div className="report-view-loading">
              <VybogTALLoaderAnimation />
            </div>
          ) : isViewPopupOpen && !viewReportData ? null : (
            <>
              <div className="checkin-checkout-bar">
                <div className="user-info-row">
                  <div className="user-avatar-circle">
                    {isViewPopupOpen
                      ? getInitials(
                          viewReportData?.first_name,
                          viewReportData?.last_name,
                        )
                      : getInitials(
                          userDetails?.first_name,
                          userDetails?.last_name,
                        )}
                  </div>
                  <div>
                    <div className="user-name-display">
                      {isViewPopupOpen
                        ? `${viewReportData?.first_name} ${viewReportData?.last_name}`
                        : `${userDetails?.first_name} ${userDetails?.last_name}`}
                    </div>
                  </div>
                </div>
                <div>
                  <div className="info-label">CHECK IN</div>
                  <div className="info-value">
                    {isViewPopupOpen
                      ? viewReportData?.check_in_time
                        ? moment(
                            viewReportData.check_in_time,
                            "YYYY-MM-DD hh:mm:ss A Z",
                          ).format("hh:mm A")
                        : "--:--"
                      : moment(
                          todayCheckInTime,
                          "YYYY-MM-DD hh:mm:ss A Z",
                        ).format("hh:mm A")}
                  </div>
                </div>
                <div>
                  <div className="info-label">CHECK OUT</div>
                  <div className="info-value">
                    {isViewPopupOpen
                      ? viewReportData?.check_out_time
                        ? moment(
                            viewReportData.check_out_time,
                            "YYYY-MM-DD hh:mm:ss A Z",
                          ).format("hh:mm A")
                        : "--:--"
                      : formatClockTime(checkOutTime)}
                  </div>
                </div>
                <div>
                  <div className="info-label">SUBMITTED ON</div>
                  <div className="info-value">
                    {isViewPopupOpen
                      ? viewReportData?.report_date
                        ? moment(viewReportData.report_date).format(
                            "ddd, MMM D",
                          )
                        : "--"
                      : formatDateHeader(new Date())}
                  </div>
                </div>
              </div>

              <div className="daily-report-submit-layout">
                <div className="daily-report-submit-remarks-panel">
                  {isViewPopupOpen ? (
                    <div className="report-remarks-readonly">
                      <label className="report-remarks-label">
                        Report Remarks
                      </label>
                      <p className="report-remarks-text">
                        {viewReportData?.report_content ||
                          "No remarks provided"}
                      </p>
                    </div>
                  ) : (
                    <TextArea
                      name="remarks"
                      label="Report Remarks"
                      placeholder="Enter your daily report remarks..."
                      value={formik.values.remarks}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={formik.touched.remarks && formik.errors.remarks}
                      errorMessage={formik.errors.remarks}
                      required={true}
                      rows="5"
                      className="remarks-textarea"
                      containerClassName="daily-report-submit-remarks-field"
                      style={{ height: "100%" }}
                    />
                  )}
                </div>

                <div className="daily-report-submit-side-panel">
                  <div className="metrics-card-wrapper daily-report-submit-side-card">
                    <MetricsCard metrics={metricsData} />
                  </div>

                  <div
                    className="daily-report-submit-side-card daily-report-submit-recent-card"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: 700,
                        marginBottom: "16px",
                        flexShrink: 0,
                      }}
                    >
                      Recent activity
                    </div>
                    <div>
                      {recentActivityLoading && recentActivity.length === 0 ? (
                        <VybogTALLoaderAnimation />
                      ) : recentActivity.length === 0 ? (
                        <div className="recent-activity-fallbacks">
                          <img
                            src={isDarkMode ? NoActivityDark : NoActivityLight}
                            className="member-dashboard-fallback-img"
                            alt="member-dashboard-fallback-img"
                          />
                          <span className="member-dashboard-fallback-text">
                            All your recent actions will show up here.
                          </span>
                        </div>
                      ) : (
                        <>
                          {renderRecentActivity()}
                          {recentActivityLoading && <VybogTALLoaderAnimation />}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </SidePopup>

      <ContentDialog
        isOpen={isEditPopupOpen}
        onClose={handleCloseEditPopup}
        onCloseIconClose={handleCloseEditPopup}
        title="Edit Daily Report"
        showTitle={true}
        showCloseIcon={true}
        showActionButton={true}
        submitButtonLabel={isEditSubmitting ? "Updating..." : "Update Report"}
        cancelButtonLabel="Cancel"
        event={handleEditSubmit}
        isSubmitDisabled={!editRemarks.trim() || isEditSubmitting}
        contentWidth="500px"
        // overflowY={true}
        submitButtonStyle={{
          backgroundColor: "#6860ee",
          color: "#ffffff",
          border: "none",
          padding: "8px 24px",
          borderRadius: "8px",
          cursor: isEditSubmitting ? "not-allowed" : "pointer",
        }}
      >
        <div style={{ padding: "20px 24px" }}>
          <div style={{ marginBottom: "16px" }}>
            <TextArea
              name="remarks"
              label="Report Remarks"
              placeholder="Edit your daily report remarks..."
              value={editRemarks}
              onChange={(e) => setEditRemarks(e.target.value)}
              onBlur={(e) => {
                e.target.style.borderColor = "var(--border-color, #e0e0e0)";
              }}
              required={true}
              rows="10"
              className="remarks-textarea"
              containerClassName="daily-report-submit-remarks-field"
              style={{ height: "100%" }}
            />
          </div>
        </div>
      </ContentDialog>
      {openRangePicker && rangePickerPosition.top !== null && (
        <CustomDatePickerModal
          initialDate={
            openRangePicker === "from"
              ? fromDate || new Date()
              : toDate || new Date()
          }
          maxDate={new Date()}
          disablePast={false}
          onOk={(date) => {
            if (openRangePicker === "from") {
              handleFromDateSelect(date);
            } else {
              handleToDateSelect(date);
            }
          }}
          onClose={() => {
            setOpenRangePicker(null);
            setRangePickerPosition({ top: null, left: null });
          }}
          top={rangePickerPosition.top}
          left={rangePickerPosition.left}
          zIndex={1300}
        />
      )}
    </div>
  );
}

export default DailyReport;
